module.exports = __webpack_public_path__ + "static/img/table_bg.81bb178a.png";